import "./cookies.css";
import { useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from '../contextApi/ContextApi';

export default function Cookies() {
    const {setCookiesApprooved, accent_color, primary_color, secondary_color} = useContext(AppContext);
    const [showBanner, setShowBanner] = useState(true);
    const [selection, setSelection] = useState(false);
    const [cancleFlag, setCancleFlag] = useState(false);
    const [approveFlag, setApproveFlag] = useState(false);
    const bannerRef = useRef();
    useEffect(()=>{
        if(bannerRef.current){
            bannerRef.current.className = showBanner ? "cookiesBanner_appear" : "cookiesBanner_disappear"
        }
        if(!showBanner){
            const timer = setTimeout(() => {
                setCookiesApprooved(selection);
            }, 1500);
            return ()=>clearTimeout(timer);
        }

    },[showBanner, selection, setCookiesApprooved])

    return (
        <div ref={bannerRef} style={{backgroundColor:primary_color || "rgba(30, 70, 130, 1)", color:accent_color || "white", border:`0.5px solid ${accent_color}`}} className="cookiesBanner_disappear">
            <h3 style={{margin:"0", padding:"0 40px"}} dir='rtl'>{"האתר משתמש בעוגיות לצורך שיפור חווית הגלישה, במידה ותבחר/י ללחוץ על 'ביטול' את/ה עלול/ה לחוות בעיות טכניות באתר"}</h3>
            <div>
                <button style={{backgroundColor:cancleFlag ? secondary_color||"rgba(80, 120, 180, 1)" : accent_color||"white", color:cancleFlag ? accent_color||"white" : primary_color||"rgba(30, 70, 130, 1)"}} className="cookiesBanner_btns" onClick={()=>{setSelection(false); setShowBanner(false)}} onMouseEnter={()=>{setCancleFlag(true)}} onMouseLeave={()=>{setCancleFlag(false)}}>ביטול</button>
                <button style={{backgroundColor:approveFlag ? secondary_color||"rgba(80, 120, 180, 1)" : accent_color||"white", color: approveFlag ? accent_color||"white" : primary_color||"rgba(30, 70, 130, 1)"}} className="cookiesBanner_btns" onClick={()=>{setSelection(true); setShowBanner(false)}} onMouseEnter={()=>{setApproveFlag(true)}} onMouseLeave={()=>{setApproveFlag(false)}}>אישור</button>
            </div>
        </div>
    )
}
